module.exports = __webpack_public_path__ + "static/scale-model-of-colonel-thomas-baker-memorial-in-bakersfield-california-877b7c5e2cd530c02f8d66d2c0eee033.png";